import { Base } from "./base";

export class Address extends Base {
    investor_id: number;
    street: string;
    number: string;
    neighborhood: string;
    city: string;
    state: string;
    constructor(json?: Object) {
        super(json);
    }
    getFullAddress(): string {
        let fullAddress: string = '';
        if (this.street) fullAddress = `${fullAddress} ${this.street}`;
        if (this.number) fullAddress = `${fullAddress} #${this.number}`;
        if (this.neighborhood) fullAddress = `${fullAddress}, ${this.neighborhood}`;
        if (this && 'zipcode' in this && this['zipcode']) fullAddress = `${fullAddress}. ${this['zipcode']}`;
        if (this.city) fullAddress = `${fullAddress}. ${this.city}`;
        if (this.state) fullAddress = `${fullAddress}, ${this.state}`;
        return fullAddress;
    }
    toString(): string {
        return this.getFullAddress();
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/Classes/address.ts